import { TOKEN_SET } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export interface TokenState {
    tokenSet: boolean
}

// Define an initial state value for the app
const initialState: TokenState = {
   tokenSet: false
}

export function tokenReducer(state = initialState, action: AppAction): TokenState | Record<string, unknown> {

    const { value } = action;

    switch (action.type) {
        case TOKEN_SET:
            return {
                ...state,
                tokenSet: value
            }
        default:
            return state
    }
}